export enum TabType {
  Msg = 'msg',
  Grouup = 'grouup'
}
